import qs from 'qs'
import { createLogic } from 'redux-logic'
import { memoizedSystemMessages } from 'store/selector/message'

const parseErrorResponseData = async (error) => {
  const responseData = error?.response?.data

  if (!responseData) {
    return null
  }

  if (typeof responseData === 'string') {
    try {
      return JSON.parse(responseData)
    } catch {
      return null
    }
  }

  if (typeof Blob !== 'undefined' && responseData instanceof Blob) {
    const blobText = await responseData.text()

    if (!blobText) {
      return null
    }

    try {
      return JSON.parse(blobText)
    } catch {
      return null
    }
  }

  if (typeof responseData === 'object') {
    return responseData
  }

  return null
}

// eslint-disable-next-line import/prefer-default-export
export const bindRequestLogic = ({
  clientFunc,
  type = '',
  successType = '',
  failType = '',
  validate,
  isQueryParam,
  modelName,
  mapResponse
}) =>
  createLogic({
    type,
    latest: true,
    validate,

    async process({ action, getState }, dispatch, done) {
      const { payload = {}, meta = {} } = action
      const { onSuccess, onError } = meta
      if (!type.startsWith('GET_SYSTEM_') && type.startsWith('GET_')) {
        dispatch({
          type: successType,
          payload: null,
          meta: { params: payload }
        })
      }

      try {
        let res
        const { id } = payload
        let payloadReq = payload.data || payload
        if (isQueryParam) {
          payloadReq = qs.stringify(payloadReq, { arrayFormat: 'brackets' })
        }
        if (id) {
          res = await clientFunc(id, payloadReq, meta)
        } else {
          res = await clientFunc(payloadReq, meta)
        }
        const payloadRes = modelName ? res?.data[modelName] : res?.data

        dispatch({
          type: successType,
          payload: mapResponse ? mapResponse(payloadRes, payload) : payloadRes,
          meta: { params: payload, ...meta },
          responseHeaders: res?.headers
        })

        if (onSuccess) {
          onSuccess({ response: res?.data, headers: res?.headers })
        }
      } catch (error) {
        const parsedErrorData = await parseErrorResponseData(error)
        const originalMsg = parsedErrorData?.message
        const systemMsg = memoizedSystemMessages(getState())
        const errorMsgStr =
          systemMsg[originalMsg?.code] ||
          originalMsg?.text ||
          (typeof originalMsg === 'string' ? originalMsg : null) ||
          error?.message
        dispatch({ type: failType, payload: errorMsgStr, error: true })

        if (onError) {
          // Third argument: the whole parsed error body, for refusals that carry
          // structured keys beside `message` (e.g. `holdingCampaign`).
          onError(errorMsgStr, originalMsg, parsedErrorData)
        }
      }
      done()
    }
  })
